export default {"src":"/blog/_next/static/media/chev_down.14684450.svg","height":10,"width":18};